import React from "react";
import { useTranslation } from "react-i18next";

import { List, ListItem, ListIcon } from "@chakra-ui/react";
import { IoMdCloseCircle } from "react-icons/io";
import { MdCheckCircle } from "react-icons/md";

import { documentTypes } from "../../utils/types";

export default function DocumentsTooltipLabel({ property }) {
	const getListIcon = (bool) => (bool ? <ListIcon as={MdCheckCircle} color="green.500" /> : <ListIcon as={IoMdCloseCircle} color="red.500" />);
	const documents = property.documents;
	const { t } = useTranslation();
	return (
		<List spacing={3}>
			{documentTypes.map((dt, index) => {
				return (
					<ListItem key={index}>
						{getListIcon(documents.find((d) => d.type === dt.id && d.active))}
						{t(`types.${dt.id}`)}
					</ListItem>
				);
			})}
		</List>
	);
}
